import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { GlobalVariable } from '../config/service.config';


@Injectable({
  providedIn: 'root'
})
export class FaseService {


  fase$ = new EventEmitter<string>();
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
  constructor(private http: HttpClient) { }

  GetFaseActual(idproceso: string) {
    return this.http.post(`${this.url}ProcesoMatricula/getFase?idProceso=${idproceso}`, null, { headers: this.headersc });
  }
}